/* Define keys for react query */
export const queryKeys = {
  negotiation: "Renegotiation summary",
  vendorQuoteAssessment: "Vendor Quote Assessment",
  userDetails: "User Details",
  volumeAllocation: "Volume Allocation",
  businessCost: "Business Cost",
  businessTrend: "Business Cost Trend",
  costCompliance: "Cost Compliance",
  volumeCompliance: "Volume Compliance",
  volumeComplianceDistricts: "Volume Compliance Districts",
  complianceFilters: "Compliance Filters",
  home: "Home",
  niaOpportunity: "NIA Opportunity",
  reports: "Reports Data",
  reportFilters: "Report Filters",
  notifications: 'Notifications',
  notificaitonsCount: 'Notifications Count'
};
